<button mat-button [disabled]="disabled" (click)="!disabled && toggle()">
  <div class="fieldName">
    <i *ngIf="ascending" class="material-icons sort">arrow_drop_up</i>
    <i *ngIf="descending" class="material-icons sort">arrow_drop_down</i>
    <span class="field">{{ fieldName }}</span>
  </div>
</button>
